// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c251a8dc","455":"b6a20e60","977":"1dbd9f20"}[chunkId] + ".chunk.js";
};